import React from 'react';
import "./threePanelCards.css";

export default function ThreePanelCards({ data }) {
  const { header, subtext, buttonText, buttonLink, cards } = data;

  const handleButtonClick = () => {
    window.open(buttonLink, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="send-messages-main-container">
      <h1 className="send-messages-header">{header}</h1>

      <div className="send-messages-subtext-container">
        <p className="send-messages-subtext">{subtext}</p>
        <button onClick={handleButtonClick} className="unauth-cta-button">
          {buttonText}
        </button>
      </div>

      <div className="send-messages-subcontainers-container">
        {cards.map((card, index) => (
          <div key={index} className="send-messages-card">
            <img 
              src={card.image} 
              alt={card.header} 
              className="send-messages-card-img" 
            />
            <h3 className="send-messages-card-header">{card.header}</h3>
            <p className="send-messages-card-subtext">{card.subtext}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
